module.exports = __webpack_public_path__ + "assets/img/question_right.3ea7eb8e.png";